<!-- 运营公众号管理 -->
<template>
  <div>
    <div id="" :style="{ width: table_scroll_width + 'px' }">
      <div
        :style="{ width: body_width + 'px' }"
        style="position: sticky; left: 30px; z-index: 5"
      >
        <!-- 标题 -->
        <div class="page-title">运营公众号管理</div>

        <div
          style="
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            margin: 10px 0 5px;
          "
        >
          <div class="screen-box">
            <div class="screen-label">公众号名称</div>
            <a-input
              v-model="r_gzh_name"
              allowClear
              placeholder="请输入公众号名称"
              style="width: 180px"
            />
          </div>

          <div class="screen-box">
            <div class="screen-label">Appid</div>
            <a-input
              v-model="r_appid"
              allowClear
              placeholder="请输入Appid"
              style="width: 190px"
            />
          </div>

          <div class="screen-box">
            <div class="screen-label">渠道</div>
            <a-select
              style="min-width: 180px"
              placeholder="请选择渠道"
              @change="handleChangeA"
              :filter-option="filterOption"
              :getPopupContainer="getsPopupContainer"
              allowClear
              showSearch
            >
              <a-select-option
                v-for="(value, key) in searchSelect.channel"
                :key="key"
                :value="key"
              >
                {{ value }}
              </a-select-option>
            </a-select>
          </div>

          <div class="screen-box">
            <div class="screen-label">状态</div>
            <a-select
              style="min-width: 180px"
              placeholder="请选择状态"
              @change="handleChangeS"
              :filter-option="filterOption"
              :getPopupContainer="getsPopupContainer"
              allowClear
              showSearch
            >
              <a-select-option value="1">正常</a-select-option>
              <a-select-option value="14">已注销</a-select-option>
              <a-select-option value="16">已封禁</a-select-option>
              <a-select-option value="18">已告警</a-select-option>
              <a-select-option value="19">已冻结</a-select-option>
            </a-select>
          </div>

          <div class="screen-box">
            <div class="screen-label">管理员</div>
            <a-select
              style="min-width: 160px"
              placeholder="请选择管理员"
              @change="handleChangeB"
              :filter-option="filterOption"
              :getPopupContainer="getsPopupContainer"
              allowClear
              showSearch
            >
              <a-select-option
                v-for="(value, key) in searchSelect.user"
                :key="key"
                :value="key"
              >
                {{ value }}
              </a-select-option>
            </a-select>
          </div>

          <div class="screen-box">
            <div class="screen-label">小程序</div>
            <a-select
              style="min-width: 200px"
              placeholder="请选择小程序"
              @change="handleChangeC"
              :value="r_applets_id"
              :filter-option="filterOption"
              :getPopupContainer="getsPopupContainer"
              allowClear
              showSearch
            >
              <a-select-option
                v-for="(item, index) in selectXcx"
                :key="index"
                :value="item.id"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </div>

          <a-button
            @click="searchButton('button')"
            :loading="search_button_loading"
            type="primary"
            icon="search"
            class="screen-box"
            >搜索</a-button
          >

          <a-button @click="jumpGzh" type="primary" class="screen-box"
            >授权公众号</a-button
          >

          <a-button class="screen-box" @click="setAdmin" type="primary"
            >批量设置管理员（ {{ selectedData.length }} ）</a-button
          >
        </div>
      </div>
    </div>

    <div>
      <!-- 表头 -->
      <div class="table-th" :style="{ width: table_scroll_width + 'px' }">
        <div
          class="table-th-cell-sticky"
          style="display: flex; align-items: center"
        >
          <div class="table-th-cell" :style="{ width: 50 + 'px' }">
            <a-checkbox
              :indeterminate="indeterminate"
              :checked="checkAll"
              @change="onCheckAllChange"
            ></a-checkbox>
          </div>
          <div
            class="table-th-cell"
            :style="{ width: rableTitle[0].width + 'px' }"
          >
            ID
          </div>
          <div
            class="table-th-cell"
            :style="{ width: rableTitle[1].width + 'px' }"
          >
            公众号名称
          </div>
          <div
            class="table-th-cell"
            :style="{ width: rableTitle[2].width + 'px' }"
          >
            操作
          </div>
        </div>
        <div v-for="(item, index) in rableTitle" :key="index">
          <div
            class="table-th-cell"
            v-if="index > 2"
            :style="{ width: item.width + 'px' }"
          >
            {{ item.title }}
          </div>
        </div>
      </div>

      <!-- 表格内容 -->
      <div
        v-for="(item, index) in tableShowData"
        :key="index"
        class="table-td"
        :style="{ width: table_scroll_width + 'px' }"
      >
        <div
          class="table-td-cell-sticky"
          style="display: flex; align-items: center"
          :style="{ height: item.height + 'px' }"
        >
          <!-- 选择 -->
          <div class="table-td-cell" :style="{ width: 50 + 'px' }">
            <a-checkbox
              :checked="item.checked"
              @change="onChangeCheckbox($event, index)"
            ></a-checkbox>
          </div>
          <!-- ID -->
          <div
            class="table-td-cell"
            :style="{ width: rableTitle[0].width + 'px' }"
          >
            {{ item.id }}
          </div>
          <!-- 公众号名称 -->
          <div
            class="table-td-cell"
            :style="{ width: rableTitle[1].width + 'px' }"
          >
            {{ item.gzh_name }}
          </div>
          <!-- 操作 -->
          <div
            class="table-td-cell"
            :style="{ width: rableTitle[2].width + 'px' }"
            style="display: flex; flex-wrap: wrap"
          >
            <div @click="tdCz(1, item)" class="cz-cell">同步公众号信息</div>
            <div @click="tdCz(2, item)" class="cz-cell">清空粉丝消息</div>
            <div @click="tdCz(3, item)" class="cz-cell">设置小程序</div>
            <div @click="tdCz(4, item)" class="cz-cell">生成小程序码</div>
            <div @click="tdCz(5, item)" class="cz-cell">查看小程序码</div>
            <div @click="tdCz(6, item)" class="cz-cell">跳转微信客服管理</div>
          </div>
        </div>

        <!-- APPID -->
        <div
          class="table-td-cell"
          :style="{ width: rableTitle[3].width + 'px' }"
        >
          {{ item.appid || "未设置" }}
        </div>
        <!-- 微信ID -->
        <div
          class="table-td-cell"
          :style="{ width: rableTitle[4].width + 'px' }"
        >
          <div
            @click="tdEdit(item, index, '微信ID')"
            v-if="item.put_gzh_id > 0"
            style="color: #62a8ea; cursor: pointer"
          >
            {{ item.put_gzh_wechat_id || "未设置" }}
          </div>
          <div v-else>未设置</div>
        </div>
        <!-- 原始ID -->
        <div
          class="table-td-cell"
          :style="{ width: rableTitle[5].width + 'px' }"
        >
          {{ item.original_id || "" }}
        </div>
        <!-- 公众号关注页链接 -->
        <div
          @click="tdEdit(item, index, '公众号关注页链接')"
          class="table-td-cell"
          :style="{ width: rableTitle[6].width + 'px' }"
          style="color: #62a8ea; cursor: pointer"
        >
          {{ item.jump_url || "未设置" }}
        </div>
        <!-- 渠道 -->
        <div
          @click="tdEdit(item, index, '渠道')"
          class="table-td-cell"
          :style="{ width: rableTitle[7].width + 'px' }"
          style="color: #62a8ea; cursor: pointer"
        >
          {{ item.channel_name || "未设置" }}
        </div>

        <!-- 状态 -->
        <div
          class="table-td-cell"
          :style="{ width: rableTitle[8].width + 'px' }"
        >
          {{ item.status | statusFilters }}
        </div>

        <!-- 是否授权 -->
        <div
          class="table-td-cell"
          :style="{ width: rableTitle[9].width + 'px' }"
        >
          <div
            v-if="item.is_auth_open == 0"
            style="
              background: #edc30e;
              border-radius: 3px;
              width: 50px;
              height: 25px;
              line-height: 25px;
              text-align: center;
              color: #fff;
              font-size: 12px;
            "
          >
            未授权
          </div>
          <div v-else style="display: flex; align-items: center">
            <div
              style="
                background: #21b978;
                border-radius: 3px;
                width: 50px;
                height: 25px;
                line-height: 25px;
                text-align: center;
                color: #fff;
                font-size: 12px;
              "
            >
              已授权
            </div>
          </div>
        </div>
        <!-- 是否关联投放公众号 -->
        <div
          class="table-td-cell"
          :style="{ width: rableTitle[10].width + 'px' }"
          style="display: flex; align-items: center"
        >
          <div
            v-if="item.put_gzh_id == 0"
            style="
              background: #edc30e;
              border-radius: 3px;
              width: 30px;
              height: 25px;
              line-height: 25px;
              text-align: center;
              color: #fff;
              font-size: 12px;
            "
          >
            否
          </div>
          <div v-else style="display: flex; align-items: center">
            <div
              style="
                background: #21b978;
                border-radius: 3px;
                width: 30px;
                height: 25px;
                line-height: 25px;
                text-align: center;
                color: #fff;
                font-size: 12px;
              "
            >
              是
            </div>
            <div style="margin-left: 10px">{{ item.put_gzh_id }}</div>
          </div>
        </div>
        <!-- 启用小程序个数 -->
        <div
          class="table-td-cell"
          :style="{ width: rableTitle[11].width + 'px' }"
        >
          {{ item.is_using_applets }}
        </div>
        <!-- 永久二维码 -->
        <div
          class="table-td-cell"
          :style="{ width: rableTitle[12].width + 'px' }"
        >
          <img
            v-if="item.qr_code"
            @click="showCodeImg(item.qr_code)"
            :src="item.qr_code"
            style="width: 70px; height: 70px"
            alt=""
          />
        </div>

        <!-- 管理员 -->
        <div
          @click="setAdminShow(item)"
          class="table-td-cell"
          :style="{ width: rableTitle[13].width + 'px' }"
        >
          <div
            v-if="item.admin_user"
            style="
              display: flex;
              align-items: center;
              cursor: pointer;
              color: #2f88ff;
            "
          >
            {{ item.admin_user | formatAdminUser }}
          </div>
          <div v-else style="color: #62a8ea; cursor: pointer">未设置</div>
        </div>

        <!-- 是否绑定运营公众号 -->
        <!-- <div class="table-td-cell" :style="{'width':rableTitle[14].width + 'px'}">
				
				<div v-if="item.openplatform_id == 0" style="background: #edc30e;border-radius: 3px;width: 28px;height: 28px;line-height: 28px;text-align: center;color: #fff;">
					否
				</div>
				<div v-else style="display: flex;align-items: center;">
					<div style="background: #21b978;border-radius: 3px;width: 28px;height: 28px;line-height: 28px;text-align: center;color: #fff;">
						是
					</div>
					<div style="margin-left: 10px;">{{item.openplatform_id}}</div>
				</div>
				
			</div> -->
      </div>
      <div
        style="
          position: fixed;
          right: 0;
          bottom: 0;
          z-index: 6;
          background-color: #fff;
          height: 90vh;
          width: 30px;
        "
      ></div>
      <div
        style="
          position: fixed;
          left: 0;
          bottom: 0;
          z-index: 6;
          background-color: #fff;
          height: 90vh;
          width: 30px;
        "
      ></div>

      <!-- 表格内容为空时显示 -->
      <tableNull
        :tableShowData="tableShowData"
        :table_null_width="table_null_width"
      ></tableNull>
    </div>

    <!-- 分页 -->
    <pagingCompont
      :table_scroll_width="table_scroll_width"
      :table_null_width="table_null_width"
      :r_page="r_page"
      :r_limit="r_limit"
      :table_total="table_total"
      @pagination-Change="paginationChange"
      @change-size-limit="changeSizeLimit"
    ></pagingCompont>

    <!-- 编辑单项的弹窗 -->
    <a-modal
      :title="`编辑${edit_modal_title}`"
      :visible="edit_visible"
      :confirm-loading="confirmLoading"
      cancelText="取消"
      okText="确认"
      width="600px"
      @ok="editModalOk"
      @cancel="editModalCancel"
    >
      <a-textarea
        v-if="edit_modal_title == '公众号关注页链接'"
        v-model="e_jump_url"
        placeholder="请输入公众号关注页链接"
        :auto-size="{ minRows: 2, maxRows: 6 }"
      />

      <a-input
        v-else-if="edit_modal_title == '微信ID'"
        v-model="e_wechatid"
        placeholder="请输入微信ID"
        style="width: 300px"
      />

      <div v-else-if="edit_modal_title == '渠道'">
        <a-select
          style="min-width: 230px"
          placeholder="请选择渠道"
          @change="handleChangeE"
          :value="e_channel_id"
          :filter-option="filterOption"
          :getPopupContainer="getsPopupContainer"
          allowClear
        >
          <a-select-option
            v-for="(value, key) in searchSelect.channel"
            :key="key"
            :value="key"
          >
            {{ value }}
          </a-select-option>
        </a-select>
      </div>
    </a-modal>

    <!-- 批量设置管理员 -->
    <a-modal
      :visible="pl_modal"
      title="批量设置管理员"
      okType="primary"
      width="700px"
      okText="设置"
      cancelText="取消"
      @ok="plOk"
      @cancel="plCancel"
      :confirmLoading="pl_loading"
    >
      <div style="">
        <div style="display: flex; align-items: center">
          <div style="margin-right: 15px; font-size: 15px">
            请选择要添加的管理员
          </div>
          <a-select
            style="min-width: 200px"
            placeholder="请选择管理员"
            @change="handleChangeD"
            :value="s_admin_id"
            :filter-option="filterOption"
            :getPopupContainer="getsPopupContainer"
            allowClear
          >
            <a-select-option
              v-for="(value, key) in searchSelect.user"
              :key="key"
              :value="key"
            >
              {{ value }}
            </a-select-option>
          </a-select>
        </div>
        <!-- <div style="display: flex;flex-wrap: wrap;margin: 15px 0 30px;max-height: 100px;overflow-y: auto;">
				<div style="width: 150px;display: flex;align-items: center;margin-bottom: 5px;" v-for="(item,index) in pl_select_admin" :key="index">
					<div style="margin-right: 15px;">{{item.label}}</div>
					<div @click="delSelectAdmin(index)" style="color: red;cursor: pointer;">删除</div>
				</div>
			</div> -->
        <div style="margin-bottom: 10px; margin-top: 15px">
          已选的公众号名称：
        </div>
        <div
          style="
            max-height: 360px;
            overflow-y: auto;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            cursor: default;
          "
        >
          <div
            v-for="(item, index) in selectedData"
            :key="index"
            style="
              margin-bottom: 10px;
              display: flex;
              align-items: center;
              margin-right: 10px;
            "
            class=""
          >
            <div style="width: 70px; text-align: right">id：{{ item.id }}</div>
            <span style="margin: 0 5px"> — </span>
            <div style="width: 100px">{{ item.gzh_name }}</div>
          </div>
        </div>

        <!-- <div class="">id：4 —— 李永润</div> -->
      </div>
    </a-modal>

    <!-- 设置小程序侧边栏 -->
    <a-drawer
      title="设置小程序"
      width="700px"
      placement="right"
      :closable="false"
      :visible="set_visible"
      @close="setCloseDrawer"
    >
      <div>
        <div
          v-for="(item, index) in setShowData"
          :key="index"
          class="set-xcx-box"
        >
          <div class="form-cell-box">
            <div class="class-title">
              选择小程序<span class="required-hint">*</span>
            </div>
            <a-select
              show-search
              style="min-width: 460px"
              placeholder="请选择"
              @change="setChangeA($event, item, index)"
              :value="item.applets_id"
              :filter-option="filterOption"
              :getPopupContainer="getsPopupContainer"
              allowClear
              showSearch
            >
              <a-select-option
                v-for="(item, index) in selectXcx"
                :key="index"
                :value="item.id"
              >
                {{ item.name }} (上线天数{{ item.day }})
              </a-select-option>
            </a-select>
          </div>

          <div class="form-cell-box">
            <div class="class-title">
              小程序打开内容<span class="required-hint">*</span>
            </div>

            <a-radio-group
              name="radioGroup"
              :value="item.jump_type"
              @change="jumpTypeChange($event, item)"
            >
              <a-radio :value="1"> 引导页 </a-radio>
              <a-radio :value="2"> 扫二维码 </a-radio>
            </a-radio-group>
          </div>

          <div v-show="item.jump_type == 1" class="form-cell-box">
            <div class="class-title">
              小程序跳转地址<span class="required-hint">*</span>
            </div>

            <a-input
              v-model="item.jump_url"
              placeholder="请输入"
              style="width: 460px"
            />
          </div>

          <div class="form-cell-box">
            <div class="class-title">
              是否启用<span class="required-hint">*</span>
            </div>

            <a-switch
              :checked="item.checked"
              @change="setChangeB($event, item)"
              default-checked
              checked-children="启用"
              un-checked-children="暂停"
            />
          </div>

          <div class="form-cell-box">
            <div class="class-title">
              序号<span class="required-hint">*</span>
            </div>

            <a-input-number
              id="inputNumber"
              v-model="item.sort_index"
              :min="1"
              @change="setChangeC"
            />
          </div>

          <div
            v-if="item.hint_control"
            style="
              font-size: 12px;
              color: red;
              text-align: center;
              margin-top: -5px;
            "
          >
            提示：该小程序处于下线状态，请关闭启用开关再保存
          </div>

          <a-icon
            @click="setDel(index)"
            style="
              position: absolute;
              right: 7px;
              top: 7px;
              font-size: 20px;
              cursor: pointer;
            "
            type="close-circle"
          />
        </div>

        <div
          style="
            color: red;
            height: 23px;
            width: 100%;
            margin-top: -15px;
            margin-bottom: 10px;
          "
        >
          {{ set_form_hint }}
        </div>

        <a-button
          @click="setAddXcx"
          style="background-color: #67c23a; border-color: #67c23a"
          type="primary"
          >新增小程序</a-button
        >
      </div>

      <div class="form-cell-box" style="margin-top: 25px; margin-bottom: 50px">
        <a-button
          @click="setRequest"
          :loading="set_button_loading"
          type="primary"
          style="margin-right: 20px"
          >确认</a-button
        >
        <a-button @click="setCloseDrawer">取消</a-button>
      </div>
    </a-drawer>

    <!-- 跳转微信客服管理 -->
    <a-drawer
      title="跳转微信客服管理"
      width="1100px"
      placement="right"
      :closable="false"
      :visible="wx_visible"
      :zIndex="1001"
      @close="wxCloseDrawer"
    >
      <a-button
        @click="addWxKf('新建客服')"
        style="margin-bottom: 20px"
        type="primary"
        >新建客服</a-button
      >
      <a-button
        @click="addWxKf('人工添加客服')"
        style="margin-bottom: 20px; margin-left: 15px"
        type="primary"
        >人工添加客服</a-button
      >

      <!-- 表头 -->
      <div class="table-th" style="top: 0">
        <div v-for="(item, index) in wx_rableTitle" :key="index">
          <div class="table-th-cell" :style="{ width: item.width + 'px' }">
            {{ item.title }}
          </div>
        </div>
      </div>

      <!-- 表格内容 -->
      <div
        v-for="(item, index) in wx_tableShowData"
        :key="item.id"
        class="table-td"
      >
        <!-- ID -->
        <div
          class="table-td-cell"
          :style="{ width: wx_rableTitle[0].width + 'px' }"
        >
          {{ item.id }}
        </div>
        <!-- 企业微信名称 -->
        <div
          class="table-td-cell"
          :style="{ width: wx_rableTitle[1].width + 'px' }"
        >
          {{ item.account_name }}
        </div>
        <!-- 客服名称 -->
        <div
          class="table-td-cell"
          :style="{ width: wx_rableTitle[2].width + 'px' }"
        >
          {{ item.name }}
        </div>
        <!-- 欢迎语主角名 -->
        <div
          class="table-td-cell"
          :style="{ width: wx_rableTitle[3].width + 'px' }"
        >
          {{ item.title }}
        </div>
        <!-- 客服URL -->
        <div
          class="table-td-cell"
          :style="{ width: wx_rableTitle[4].width + 'px' }"
        >
          {{ item.kf_url }}
        </div>
        <!-- 状态 -->
        <div
          class="table-td-cell"
          :style="{ width: wx_rableTitle[5].width + 'px' }"
        >
          <!-- {{item.status | wxTableStatus}} -->
          <a-switch
            :checked="item.checked"
            :loading="item.status_checked_loading"
            @change="onChangeChecked($event, item)"
            checked-children="正常"
            un-checked-children="禁用"
            size="small"
          />
        </div>
        <!-- 使用顺序 -->
        <div
          class="table-td-cell"
          :style="{ width: wx_rableTitle[6].width + 'px' }"
        >
          <a-input-number
            @change="useSort($event, item)"
            :value="item.sort"
            :min="0"
            :max="1000"
            style="width: 70px"
          />
        </div>
        <!-- 添加方式 -->
        <div
          class="table-td-cell"
          :style="{ width: wx_rableTitle[7].width + 'px' }"
        >
          {{ item.create_type == 1 ? "人工" : "API" }}
        </div>
        <!-- 操作 -->
        <div
          class="table-td-cell"
          :style="{ width: wx_rableTitle[8].width + 'px' }"
          style="display: flex; flex-wrap: wrap"
        >
          <div @click="wxTdCz(1, item)" class="cz-cell">编辑</div>
          <div @click="wxTdCz(2, item)" class="cz-cell">解除绑定</div>
          <div @click="wxTdCz(3, item)" class="cz-cell" style="color: red">
            删除客服
          </div>
        </div>
      </div>

      <div
        v-show="wx_tableShowData.length === 0"
        style="text-align: center; text-align: center; padding: 80px 0 50px"
      >
        <a-icon style="font-size: 70px; color: #999" type="file-search" />

        <div style="color: #999; font-size: 16px; margin-top: 20px">
          内容为空
        </div>
      </div>

      <div class="form-cell-box" style="margin-top: 25px; margin-bottom: 50px">
        <a-button @click="wxCloseDrawer" style="margin-right: 20px"
          >取消</a-button
        >
        <a-button
          @click="sortRequest(1)"
          type="primary"
          style="margin-right: 20px"
          >整理顺序</a-button
        >
        <a-button
          @click="sortRequest(2)"
          :loading="sort_wx_button_loading"
          type="primary"
          style="margin-right: 20px"
          >确认顺序</a-button
        >
      </div>
    </a-drawer>

    <!-- 新增微信客服 -->
    <a-drawer
      :title="`${add_wx_drawer_title}微信客服`"
      width="1100px"
      placement="right"
      :closable="false"
      :zIndex="1002"
      :visible="add_wx_visible"
      @close="add_wxCloseDrawer"
    >
      <div v-if="add_wx_drawer_title == '新增'" class="form-cell-box">
        <div class="class-title">
          公众号<span class="required-hint">*</span>
        </div>

        <a-input
          disabled
          v-model="add_wx_gzh_name"
          placeholder="请输入"
          style="width: 500px"
        />
      </div>

      <div v-if="add_wx_drawer_title == '新增'" class="form-cell-box">
        <div class="class-title">企业<span class="required-hint">*</span></div>

        <a-select
          style="width: 500px"
          placeholder="请选择"
          @change="handleChangeH"
          :value="add_wx_kf_account_id"
        >
          <a-select-option value="0">未选择</a-select-option>
          <a-select-option
            v-for="(item, index) in addWxSelect"
            :key="item.id"
            :value="item.id"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </div>

      <div v-if="wx_button_type == '新建客服'" class="form-cell-box">
        <div class="class-title" style="flex-shrink: 0">
          客服头像<span class="required-hint">*</span>
        </div>

        <div
          v-if="!add_wx_kf_account_id"
          @click="upImgHint"
          style="
            width: 100px;
            height: 100px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            border: 1px dashed #ccc;
            cursor: pointer;
          "
        >
          <a-icon :type="loading ? 'loading' : 'plus'" />
          <div class="ant-upload-text">上传图片</div>
        </div>
        <div v-else>
          <a-upload
            accept="image/*"
            name="file"
            list-type="picture-card"
            class="avatar-uploader"
            style="max-width: 450px"
            :show-upload-list="false"
            :action="`${$http.excel_url}api/enterwx/upload/image`"
            :before-upload="beforeUpload"
            @change="handleChangeImg"
            :withCredentials="true"
            method="post"
            :data="{
              name: 'Image.png',
              account_id: add_wx_kf_account_id,
            }"
            :headers="{
              Authorization: headers_token,
            }"
          >
            <img v-if="imageUrl" :src="imageUrl" alt="avatar" />
            <div v-else>
              <a-icon :type="loading ? 'loading' : 'plus'" />
              <div class="ant-upload-text">上传图片</div>
            </div>
          </a-upload>
        </div>
      </div>

      <div class="form-cell-box">
        <div class="class-title">
          客服名称<span class="required-hint">*</span>
        </div>

        <a-input
          v-model="add_wx_name"
          placeholder="请输入"
          style="width: 500px"
        />
      </div>

      <div v-if="wx_button_type == '新建客服'" class="form-cell-box">
        <div class="class-title">
          欢迎语主角词<span class="required-hint">*</span>
        </div>

        <a-input
          v-model="add_wx_title"
          placeholder="请输入"
          style="width: 500px"
        />
      </div>

      <div v-if="wx_button_type == '人工添加客服'" class="form-cell-box">
        <div class="class-title">
          客服URL<span class="required-hint">*</span>
        </div>

        <a-input
          v-model="add_kf_url"
          placeholder="请输入"
          style="width: 500px"
        />
      </div>

      <div class="form-cell-box">
        <div class="class-title">
          使用顺序值<span class="required-hint">*</span>
        </div>

        <a-input-number
          @change="addUseSort"
          :value="add_wx_sort"
          :min="0"
          :max="1000"
          style="width: 500px"
        />
      </div>

      <div class="form-cell-box" style="margin-top: 25px; margin-bottom: 50px">
        <a-button
          @click="wxRequest"
          :loading="add_wx_button_loading"
          type="primary"
          style="margin-right: 20px"
          >确认</a-button
        >
        <a-button @click="add_wxCloseDrawer">取消</a-button>
      </div>
    </a-drawer>

    <!-- 图片查看 -->
    <a-modal
      v-model="img_visible"
      width="350px"
      title="图片展示"
      @ok="imgOk"
      okText="确认"
      cancelText="取消"
      :footer="null"
    >
      <img
        style="width: 300px; max-height: 500px; object-fit: contain"
        :src="show_modal_img"
        alt=""
      />
    </a-modal>

    <!-- 加载中 -->
    <div class="loading-box" v-show="search_button_loading">
      <a-spin size="large" />
    </div>
  </div>
</template>

<script>
function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
}
import {
  opeGzhList,
  putDataMenu,
  putGzhSetWechatid,
  opeGzhSelect,
  opeGzhXcx,
  opeGzhSetUser,
  opeGzhSetJumpUrl,
  opeGzhSetChannel,
  opeGzhSyncGzhInfo,
  opeGzhClearMessage,
  opeGzhGenerateAppletCode,
  opeGzhGetApplets,
  opeGzhEditApplets,
  opeGzhWxKf,
  opeGzhSelectWxQy,
  opeGzhAddImg,
  opeGzhAddKf,
  opeGzhKfStatus,
  opeGzhEditKf,
  opeGzhManAddKf,
  opeGzhManEditKf,
  opeGzhChangeStatus,
  opeGzhChangeSort,
} from "@/request/api";
export default {
  name: "openGzh_",
  components: {},
  data() {
    return {
      // 表格部分内容
      // 表格的表头，规定宽度和要用的其他信息
      rableTitle: [
        { title: "ID", width: 70, type: "id" }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
        { title: "公众号名称", width: 100, type: "gzh_name" },
        { title: "操作", width: 210, type: "cz" },

        { title: "APPID", width: 160, type: "appid" },
        { title: "微信ID", width: 140, type: "put_gzh_wechat_id" },
        { title: "原始ID", width: 160, type: "original_id" },
        { title: "公众号关注页链接", width: 200, type: "jump_url" },
        { title: "渠道", width: 100, type: "channel_name" },

        { title: "状态", width: 100, type: "status" },

        { title: "是否授权", width: 90, type: "is_auth_open" },
        { title: "是否关联投放公众号", width: 150, type: "put_gzh_id" },
        { title: "启用小程序个数", width: 120, type: "is_using_applets" },
        { title: "永久二维码", width: 120, type: "qr_code" },

        { title: "管理员", width: 160, type: "admin_user" },
        // {title:"操作", width:80, type:"cz", },
      ],
      tableShowData: [],
      body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
      table_scroll_width: 1000,
      table_null_width: 1000, // 表格内容为空时，空提示的宽度范围
      search_button_loading: false,

      r_page: 1,
      r_limit: 20,
      table_total: 0,

      r_gzh_name: null, // 公众号名称
      r_appid: null, // appid
      r_channel_id: undefined, // 选择渠道
      r_admin_id: undefined, // 管理员
      r_applets_id: undefined, // 选择的小程序
      r_status: undefined, // 公众号状态

      // 多选
      indeterminate: false,
      checkAll: false,
      selectedData: [], // 选择内容存放数组

      // 筛选条件部分
      filterData: {
        op_id: {
          list: [{}],
        },

        media_id: {
          list: [{}],
        },
        channel_id: {
          list: [{}],
        },
        gzh_id: {
          list: [{}],
        },
      }, // 筛选条件数组

      // 单个编辑弹窗
      edit_visible: false, // 编辑弹窗的显示
      edit_modal_title: "", // 编辑弹窗的标题
      confirmLoading: false,
      e_jump_url: "", // 编辑公众号关注页链接请求需要的参数
      e_wechatid: "", // 编辑微信ID请求需要的参数
      e_id: "", // 编辑请求用的id
      e_channel_id: undefined, // 渠道编辑

      // 批量设置管理员
      pl_modal: false,
      pl_loading: false,
      pl_select_admin: [],
      s_admin_id: undefined, // 设置管理员的管理员id

      searchSelect: [{}],
      selectXcx: [],

      // 设置小程序
      set_visible: false,
      set_form_hint: "", // 设置小程序侧边栏的提示
      set_button_loading: false,
      setShowData: [], // 展示内容的数据
      set_applets_id: "", // 要设置的小程序请求用的id

      // 微信客服
      wx_visible: false, // 微信客服管理侧边栏控制
      wx_rableTitle: [
        { title: "ID", width: 50, type: "id" }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
        { title: "企业微信名称", width: 110, type: "account_name" },
        { title: "客服名称", width: 120, type: "name" },
        { title: "欢迎语主角名", width: 100, type: "put_gzh_wechat_id" },
        { title: "客服URL", width: 190, type: "kf_url" },
        { title: "状态", width: 80, type: "status" },
        { title: "使用顺序", width: 100, type: "sort" },
        { title: "添加方式", width: 80, type: "create_type" },
        { title: "操作", width: 160, type: "cz" },
      ],
      wx_tableShowData: [],
      wx_button_type: "", // 按钮类型，新建客服 或 人工添加客服
      // 新建微信客服
      add_wx_visible: false,
      add_wx_button_loading: false,
      add_wx_name: "", // 客服名称
      add_wx_title: "", // 欢迎语主角词
      addWxSelect: [], // 新增微信客服的企业下拉选择框
      add_wx_gzh_name: "", // 公众号名字
      wx_kf_get_id: "", // 获取客服管理表格数据的id
      add_kf_url: "", // 客服URL
      add_wx_sort: 0, // 排序值，默认为0

      loading: false,
      imageUrl: "",
      add_wx_kf_account_id: undefined, // 新建微信客服上传头像要用的id
      add_wx_kf_media_id: "", // 图片上传后的参数
      add_wx_drawer_title: "新增", // 客服侧边栏标题：新增/编辑
      edit_wx_kf_id: "", // 编辑用的id
      headers_token: "", // 图片上传用的token

      // 图片展示
      img_visible: false,
      show_modal_img: "", // 图片链接

      // 更改微信客服管理表格顺序
      sort_wx_button_loading: false,
    };
  },
  mounted() {
    let that = this;

    that.search_button_loading = true;

    that.body_width = document.body.clientWidth - 60 - 50; // 筛选条件大盒子的宽度
    let nn = 0;
    that.rableTitle.forEach((res, index) => {
      nn = nn + res.width;
    });
    that.table_scroll_width = nn + 30 + 60;
    if (that.table_scroll_width >= that.body_width) {
      that.table_null_width = that.body_width - 60;
    } else {
      that.table_null_width = that.table_scroll_width - 60;
    }

    console.log(this.$route.query);
    if (this.$route.query) {
      // 接收从小程序跳转码页面传过来的参数、小程序跳转码每日使用量页
      if (this.$route.query.gzh_name) {
        this.r_gzh_name = this.$route.query.gzh_name;
      }

      // 从小程序管理-运营版跳过来
      if (this.$route.query.applets_id) {
        this.r_applets_id = Number(this.$route.query.applets_id);
      }
    }

    this.headers_token = "Bearer " + localStorage.getItem("access_token");

    putDataMenu().then((res) => {
      console.log("获取搜索条件", res);
      that.filterData = res.data.data.filter;
    });

    opeGzhSelect().then((res) => {
      console.log("获取渠道、管理员选择", res);
      that.searchSelect = res.data.data;
    });

    opeGzhXcx().then((res) => {
      console.log("获取小程序", res);
      that.selectXcx = res.data.data.applets;
    });

    that.searchButton();

    opeGzhSelectWxQy().then((res) => {
      console.log("获取新增微信客服的企业下拉选择框", res);
      that.addWxSelect = res.data.data.data;
    });
  },
  methods: {
    // 给ant design的select选择器重新设置定位
    getsPopupContainer(triggerNode) {
      // console.log("getsPopupContainer",triggerNode)
      return triggerNode.parentNode || document.body;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    // 请选择渠道
    handleChangeA(e) {
      this.r_channel_id = e;
    },
    // 请选择管理员
    handleChangeB(e) {
      this.r_admin_id = e;
    },
    // 选择的小程序
    handleChangeC(e) {
      this.r_applets_id = e;
    },
    // 批量设置管理员，选择管理员
    handleChangeD(e) {
      console.log(e);
      this.s_admin_id = e;
      // let ttt = true
      // this.pl_select_admin.forEach(res=>{
      // 	if(res.key == e.key){
      // 		ttt = false
      // 	}
      // })
      // if(ttt){
      // 	this.pl_select_admin.push(e)
      // }
    },
    // 编辑渠道
    handleChangeE(e) {
      console.log(e);
      this.e_channel_id = e;
    },
    // 选择状态
    handleChangeS(e) {
      this.r_status = e;
    },
    // 删除选择的管理员
    delSelectAdmin(index) {
      this.pl_select_admin.splice(index, 1);
    },
    // 搜索
    searchButton(type) {
      let that = this;
      that.search_button_loading = true;

      if (type != "分页") {
        // 除开分页以外的请求都要把选中状态清空
        that.selectedData = []; // 已选内容清空
        that.r_page = 1;
      }

      opeGzhList({
        page: that.r_page,
        limit: that.r_limit,
        gzh_name: that.r_gzh_name, // 公众号名称
        appid: that.r_appid, // appid
        channel_id: that.r_channel_id, // 选择渠道
        admin_id: that.r_admin_id, // 管理员
        applets_id: that.r_applets_id, // 选择的小程序

        status: that.r_status, // 状态
      }).then((res) => {
        console.log("搜索结果", res);
        if (
          res.data.code === 0 ||
          res.data.code === 200 ||
          res.data.code == 8011
        ) {
          let data = res.data.data.data;
          data.forEach((res) => {
            res.checked = false; // 用于多选和单选
            if (res.gzh_report_config) {
              if (res.gzh_report_config.bd_report_status == 1) {
                res.bd_checked = true;
              } else {
                res.bd_checked = false;
              }
            } else {
              res.bd_checked = false;
            }
          });

          if (that.selectedData.length > 0) {
            let ccc = true;
            let iii = 0; // 用于判断是否全选
            data.forEach((res) => {
              that.selectedData.forEach((res_r) => {
                if (res.id === res_r.id) {
                  res.checked = true;
                  ccc = false;
                  iii = iii + 1;
                }
              });
            });
            console.log("iii", iii);
            if (iii === 20) {
              // 全选
              that.indeterminate = false;
              that.checkAll = true;
            } else {
              if (ccc) {
                that.checkAll = false;
                that.indeterminate = false;
              } else {
                that.checkAll = false;
                that.indeterminate = true;
              }
            }
          } else {
            console.log("that.checkAll", that.checkAll);
            that.checkAll = false;
            that.indeterminate = false;
          }

          that.search_button_loading = false;
          that.table_total = res.data.data.total;
          console.log("data", data);
          that.tableShowData = data;
        } else {
          that.search_button_loading = false;
          if (res.data.code === 401) {
            // 未登录
            localStorage.removeItem("access_token");
            that.$router.replace({
              name: "login",
              params: { type: "not_log" },
            });
          } else {
            that.$message.error(`错误：${res.data.msg}`);
          }
        }

        // 在打开了ant design的侧边栏组件之后，每次调搜索请求，body身上都会被加上overflow-x: hidden，就会导致横向滚动条失效，所以要按照下面这么搞
        document
          .querySelector("body")
          .setAttribute("style", "overflow-x: visible;");
        setTimeout(() => {
          document
            .querySelector("body")
            .setAttribute("style", "overflow-x: visible;");
        }, 300);
      });
    },
    // 分页
    paginationChange(e) {
      this.r_page = e;
      this.searchButton("分页");
    },
    changeSizeLimit(e) {
      // console.log('每页多少条',e)
      this.r_limit = e;
      this.searchButton("button");
    },

    // 巨量链接复制
    mkUrlCopy(e) {
      console.log(e);
      let that = this;
      this.$copyText(e.mk_click_url)
        .then((res) => {
          that.$message.success("复制成功");
        })
        .catch((err) => {
          that.$message.error("复制失败");
        });
    },
    // 批量设置管理员
    setAdmin() {
      if (this.selectedData.length > 0) {
        this.pl_modal = true;
      } else {
        this.$message.warning("请先选择内容");
      }
    },
    // 全选
    onCheckAllChange(e) {
      let that = this;
      if (that.checkAll) {
        that.tableShowData.forEach((res) => {
          res.checked = false;
        });
        that.checkAll = false;

        that.selectedData = []; // 取消全选的时候，全部清除
      } else {
        that.tableShowData.forEach((res) => {
          res.checked = true;
          // 有重复的就不要传了
          let ddd = true;
          that.selectedData.forEach((res_r) => {
            if (res_r.id === res.id) {
              ddd = false;
              console.log("l", ddd);
            }
          });

          if (ddd) {
            console.log("w", ddd);
            that.selectedData.push(res);
          }
        });

        that.indeterminate = false;
        that.checkAll = true;
      }
    },
    // 单选
    onChangeCheckbox(checkedList, index) {
      let that = this;
      if (that.tableShowData[index].checked) {
        // 为选中状态，然后要改为未选中状态
        that.tableShowData[index].checked = false;

        let iii;
        console.log(
          "that.tableShowData[index].id",
          that.tableShowData[index].id
        );
        that.selectedData.forEach((res, index_z) => {
          if (res.id == that.tableShowData[index].id) {
            iii = index_z;
          }
        });
        that.selectedData.splice(iii, 1);
        console.log("iii", iii);
      } else {
        // 未选中状态改为选中状态
        that.tableShowData[index].checked = true;
        if (that.selectedData.length === 0) {
          that.selectedData.push(that.tableShowData[index]);
        } else {
          // 判断有没有重复的内容，如果里面已经有重复的内容了，就不用再传了
          let ddd = true;
          for (let i = 0; i < that.selectedData.length; i++) {
            if (that.selectedData[i].id === that.tableShowData[index].id) {
              ddd = false;
              break;
            }
          }
          if (ddd) {
            that.selectedData.push(that.tableShowData[index]);
          }
        }
      }
      // that.tableShowData[index].checked = !that.tableShowData[index].checked
      console.log("that.selectedData", that.selectedData);
      let ccc = true;
      let iii = false;
      let nnn = that.selectedData.length || 0;
      console.log("that.selectedData.length", that.selectedData.length);
      that.tableShowData.forEach((res) => {
        if (res.checked) {
          iii = true;
          // nnn = nnn + 1
        }
        if (!res.checked) {
          ccc = false;
        }
      });
      // console.log("nnn",nnn)
      if (ccc) {
        that.indeterminate = false;
      } else {
        that.indeterminate = iii;
      }
      that.checkAll = ccc;
    },

    // 表格单元格内的编辑按钮
    tdEdit(e, index, type) {
      console.log(e);
      // console.log(index);
      // console.log(type);

      if (type == "公众号关注页链接") {
        this.e_id = e.id;
        this.e_jump_url = e.jump_url;
      } else if (type == "微信ID") {
        this.e_id = e.put_gzh_id;
        this.e_wechatid = e.put_gzh_wechat_id;
      } else if (type == "渠道") {
        this.e_id = e.id;
        this.e_channel_id = e.channel_id.toString();
      }
      this.edit_modal_title = type;
      this.edit_visible = true;
    },
    // 编辑弹窗确认按钮
    editModalOk() {
      let that = this;
      that.confirmLoading = true;
      if (that.edit_modal_title == "公众号关注页链接") {
        opeGzhSetJumpUrl({
          id: that.e_id,
          jump_url: that.e_jump_url,
        })
          .then((res) => {
            that.confirmLoading = false;
            console.log("公众号关注页链接", res);
            that.editModalCancel();
            that.$message.success("编辑成功");
            that.searchButton();
          })
          .catch((err) => {
            that.confirmLoading = false;
          });
      } else if (that.edit_modal_title == "微信ID") {
        putGzhSetWechatid({
          id: that.e_id,
          wechatid: that.e_wechatid,
        })
          .then((res) => {
            that.confirmLoading = false;
            console.log("微信ID", res);
            that.editModalCancel();
            that.$message.success("编辑成功");
            that.searchButton();
          })
          .catch((err) => {
            that.confirmLoading = false;
          });
      } else if (that.edit_modal_title == "渠道") {
        opeGzhSetChannel({
          id: that.e_id,
          channel_id: that.e_channel_id || "0", //如果用户什么都不传，就要默认传一个0
        }).then((res) => {
          that.confirmLoading = false;
          console.log("渠道", res);
          that.editModalCancel();
          that.$message.success("编辑成功");
          that.searchButton();
        });
      }
    },
    // 编辑弹窗取消
    editModalCancel() {
      if (this.confirmLoading) {
        return;
      }
      this.edit_visible = false;
    },
    // 批量设置管理员弹窗确认按钮
    plOk() {
      let that = this;
      // if(that.pl_select_admin.length > 0){ // 得选择管理员
      that.pl_loading = true;
      let a_data = [];
      that.pl_select_admin.forEach((res) => {
        a_data.push(res.key);
      });
      console.log("a_data", a_data);

      let i_data = [];
      that.selectedData.forEach((res) => {
        i_data.push(res.id);
      });
      console.log("i_data", i_data);

      opeGzhSetUser({
        admin_id: that.s_admin_id,
        ids: i_data,
      }).then((res) => {
        that.pl_loading = false;
        console.log("批量设置管理员", res);
        that.selectedData = [];
        that.plCancel();
        that.$message.success("设置成功");
        that.searchButton();
      });
      // }
      // else {
      // 	this.$message.warning('请先选择管理员');
      // }
    },
    // 批量设置管理员弹窗取消按钮
    plCancel() {
      if (this.pl_loading) {
        return;
      }
      this.pl_select_admin = [];
      this.pl_modal = false;
      this.selectedData = [];
    },
    // 表格-管理员项的编辑
    setAdminShow(e) {
      let that = this;
      this.selectedData = [];
      // 这里清空状态是为了避免批量设置和单个设置的状态混淆
      this.tableShowData.forEach((res) => {
        res.checked = false;
      });
      this.checkAll = false;
      this.indeterminate = false;
      this.selectedData.push(e);
      console.log(e.admin_id);
      // 如果要恢复这里，记得给select组件设置labelInValue为true
      // e.gzh_user.forEach(res=>{
      // 	let obj = {
      // 		label: res.admin_name,
      // 		key: res.admin_id
      // 	}
      // 	this.pl_select_admin.push(obj)
      // })
      this.s_admin_id = e.admin_id.toString();
      this.pl_modal = true;
    },

    // 授权公众号
    jumpGzh() {
      window.open("https://admin-wx.ledu19.cn/api/open/scan_pre_code");
    },
    // 表格里的操作
    tdCz(e, item) {
      console.log("item", item);
      let that = this;
      if (e == 1) {
        // 同步公众号信息
        this.$confirm({
          title: "确定同步公众号信息吗？",
          content: `ID：${item.id}`,
          cancelText: "取消",
          okText: "确认",
          onOk() {
            that.search_button_loading = true;
            opeGzhSyncGzhInfo({
              id: item.id,
            })
              .then((res) => {
                that.search_button_loading = false;
                if (
                  res.data.code === 0 ||
                  res.data.code === 200 ||
                  res.data.code == 8011
                ) {
                  that.$message.success("操作成功");
                } else {
                  if (res.data.code === 401) {
                    // 未登录
                    localStorage.removeItem("access_token");
                    that.$router.replace({
                      name: "login",
                      params: { type: "not_log" },
                    });
                  } else {
                    that.$message.error(`错误：${res.data.msg}`);
                  }
                }
                console.log("同步公众号信息", res);
              })
              .catch((err) => {
                console.log("err", err);
                that.$message.error("操作失败，请检查请求操作");
              });
          },
          onCancel() {
            console.log("Cancel");
          },
        });
      } else if (e == 2) {
        // 清空粉丝消息
        this.$confirm({
          title: "确认要清空粉丝消息吗？",
          content: `ID：${item.id}`,
          cancelText: "取消",
          okText: "确认",
          onOk() {
            that.search_button_loading = true;
            opeGzhClearMessage({
              id: item.id,
            })
              .then((res) => {
                console.log("清空粉丝消息", res);
                that.search_button_loading = false;
                if (
                  res.data.code === 0 ||
                  res.data.code === 200 ||
                  res.data.code == 8011
                ) {
                  that.$message.success("操作成功");
                } else {
                  if (res.data.code === 401) {
                    // 未登录
                    localStorage.removeItem("access_token");
                    that.$router.replace({
                      name: "login",
                      params: { type: "not_log" },
                    });
                  } else {
                    that.$message.error(`错误：${res.data.msg}`);
                  }
                }
              })
              .catch((err) => {
                that.search_button_loading = false;
                console.log("err", err);
                that.$message.error("操作失败，请检查请求操作");
              });
          },
          onCancel() {
            console.log("Cancel");
          },
        });
      } else if (e == 3) {
        // 设置小程序
        that.search_button_loading = true;
        that.set_applets_id = item.id;
        opeGzhGetApplets({
          id: item.id,
          type: 0,
        }).then((res) => {
          that.search_button_loading = false;
          console.log("设置小程序", res.data.data);

          if (
            res.data.code == 0 ||
            res.data.code == 200 ||
            res.data.code == 8011
          ) {
            let data = res.data.data.list;
            data.forEach((res, index) => {
              if (res.is_using == 1) {
                // 1表示启用。0表示暂停
                res.checked = true;
              } else {
                res.checked = false;
              }
              res.sort_index = index + 1;
              // 记录当前选择的小程序的状态。是开启还是关闭
              that.selectXcx.forEach((res_k) => {
                if (res.applets_id === res_k.id) {
                  res.xcx_status = res_k.status; // 1表示开启。0表示关闭
                }
              });
              res.hint_control = false; // 小程序状态的提示控制
            });
            that.setShowData = data;
            that.set_visible = true; // 显示侧边栏
          } else {
            if (res.data.code === 401) {
              // 未登录
              localStorage.removeItem("access_token");
              that.$router.replace({
                name: "login",
                params: { type: "not_log" },
              });
            } else {
              that.$message.error(`${res.data.msg}`);
            }
          }
        });
      } else if (e == 4) {
        // 生成小程序码
        this.$confirm({
          title: "确定生成小程序码吗？",
          content: `ID：${item.id}`,
          cancelText: "取消",
          okText: "确认",
          onOk() {
            that.search_button_loading = true;
            opeGzhGenerateAppletCode({
              id: item.id,
            })
              .then((res) => {
                console.log("生成小程序码", res);
                that.search_button_loading = false;
                if (
                  res.data.code === 0 ||
                  res.data.code === 200 ||
                  res.data.code == 8011
                ) {
                  that.$message.success("操作成功");
                } else {
                  if (res.data.code === 401) {
                    // 未登录
                    localStorage.removeItem("access_token");
                    that.$router.replace({
                      name: "login",
                      params: { type: "not_log" },
                    });
                  } else {
                    that.$message.error(`错误：${res.data.msg}`);
                  }
                }
              })
              .catch((err) => {
                console.log("err", err);
                that.$message.error("操作失败，请检查请求操作");
              });
          },
          onCancel() {
            console.log("Cancel");
          },
        });
      } else if (e == 5) {
        // 查看小程序码
        // item.put_gzh_id
        that.$router.push({
          path: "/xcxScheme",
          query: { gzh_id: item.put_gzh_id },
        });
      } else if (e == 6) {
        // 跳转微信客服管理
        that.search_button_loading = true;
        that.add_wx_gzh_name = item.gzh_name;
        that.wx_kf_get_id = item.id;
        // 获取客服管理表格数据
        that.getKfTable();
      }
    },
    // 设置小程序
    setRequest() {
      let that = this;

      console.log("that.setShowData", that.setShowData);
      let ccc = true;
      that.setShowData.forEach((res) => {
        if (!res.applets_id || !res.sort_index) {
          ccc = false;
        }
        // 引导页的情况下需要填写小程序跳转地址
        if (!res.jump_url && res.jump_type == 1) {
          ccc = false;
        }
      });
      if (ccc) {
        that.set_button_loading = true;
        that.set_form_hint = "";
        // 第二道检查。小程序上线状态 与 启用状态不能冲突
        let xxx = true;
        that.setShowData.forEach((res) => {
          res.hint_control = false;
          if (res.checked) {
            if (res.xcx_status != 1) {
              // 启用的小程序必须是线上状态
              res.hint_control = true;
              xxx = false;
            }
          }
        });
        if (xxx) {
          // 没有冲突就继续往下走
          console.log("校验通过");
          // 把数据处理成请求要用的格式
          // 要按照序号的大小顺序请求，要排序
          that.setShowData.sort(function (a, b) {
            return a.sort_index - b.sort_index;
          });
          console.log("that.setShowData", that.setShowData);
          let r_arr = [];
          that.setShowData.forEach((res) => {
            let obj = {
              applets_id: res.applets_id,
              jump_url: res.jump_url || "",
              jump_type: res.jump_type,
            };
            if (res.checked) {
              obj.is_using = 1;
            } else {
              obj.is_using = 0;
            }
            r_arr.push(obj);
          });
          console.log("r_arr", r_arr);
          opeGzhEditApplets({
            applets: r_arr,
            id: that.set_applets_id,
          })
            .then((res) => {
              that.set_button_loading = false;
              console.log("设置小程序", res);
              if (
                res.data.code === 0 ||
                res.data.code === 200 ||
                res.data.code == 8011
              ) {
                that.setCloseDrawer();
                that.$message.success("设置成功");
              } else {
                if (res.data.code === 401) {
                  // 未登录
                  localStorage.removeItem("access_token");
                  that.$router.replace({
                    name: "login",
                    params: { type: "not_log" },
                  });
                } else {
                  that.$message.error(`错误：${res.data.msg}`);
                }
              }
            })
            .catch((err) => {
              that.set_button_loading = false;
            });
        } else {
          that.set_button_loading = false;
        }
      } else {
        that.set_form_hint = "内容不能为空，请检查是否有遗漏";
      }
    },
    setCloseDrawer() {
      let that = this;
      if (this.set_button_loading) {
        return;
      }
      this.set_visible = false;
      this.set_form_hint = "";
    },
    setChangeA(e, item, index) {
      // 选择小程序
      console.log(e);
      console.log(item);
      console.log(this.setShowData[index]);
      this.selectXcx.forEach((res_k) => {
        if (e === res_k.id) {
          item.xcx_status = res_k.status; // 1表示开启。0表示关闭
        }
      });
      item.applets_id = e;
    },
    setChangeB(e, item) {
      // 是否启用
      console.log(e);
      item.checked = e;
    },
    setChangeC(e) {
      // 序号输入框
      console.log(e);
    },
    // 新增小程序
    setAddXcx() {
      let obj = {
        applets_id: undefined,
        jump_url: "",
        checked: true,
        hint_control: false,
        jump_type: 1, // 小程序打开内容。1为引导页。2位扫二维码
      };
      // console.log("this.setShowData",this.setShowData);
      if (this.setShowData.length > 0) {
        obj.sort_index =
          this.setShowData[this.setShowData.length - 1].sort_index + 1;
      } else {
        obj.sort_index = 1;
      }

      this.setShowData.push(obj);
    },
    // 删除准备新增的小程序
    setDel(index) {
      this.setShowData.splice(index, 1);
    },

    // 跳转微信客服管理
    wxCloseDrawer() {
      if (this.sort_wx_button_loading) {
        return;
      }
      this.wx_visible = false;
    },
    wxTdCz(e, item) {
      let that = this;
      console.log("wxTdCz", item);
      if (e == 1) {
        // 编辑
        if (item.create_type == 1) {
          //人工
          that.wx_button_type = "人工添加客服";
          that.add_kf_url = item.kf_url;
        } else {
          that.wx_button_type = "新建客服";

          that.add_wx_title = item.title;
        }
        that.edit_wx_kf_id = item.id;
        that.add_wx_drawer_title = "编辑";
        that.add_wx_visible = true;
        that.add_wx_kf_account_id = item.account_id; // 企业id
        that.add_wx_name = item.name;
      } else if (e == 2) {
        // 解除绑定
        that.$confirm({
          title: "确定解除绑定吗？",
          content: `ID：${item.id}`,
          cancelText: "取消",
          okText: "确认",
          zIndex: 1003,
          onOk() {
            that.jc_del_req(item, 2);
          },
          onCancel() {
            console.log("Cancel");
          },
        });
      } else if (e == 3) {
        // 删除客服
        that.$confirm({
          title: "确定删除吗？",
          content: `ID：${item.id}`,
          cancelText: "取消",
          okText: "确认",
          okType: "danger",
          zIndex: 1003,
          onOk() {
            that.jc_del_req(item, 3);
          },
          onCancel() {
            console.log("Cancel");
          },
        });
      }
    },
    // 解除绑定、删除的请求操作
    jc_del_req(item, status) {
      let that = this;
      opeGzhKfStatus({
        id: item.id.toString(),
        order: "id",
        sort: "asc",
        status: status, // 2为解除绑定。3为删除
      }).then((res) => {
        console.log("解除绑定/删除客服", res);
        if (
          res.data.code === 0 ||
          res.data.code === 200 ||
          res.data.code == 8011
        ) {
          // 获取客服管理表格数据
          that.getKfTable();
          that.$message.success("操作成功");
        } else {
          if (res.data.code === 401) {
            // 未登录
            localStorage.removeItem("access_token");
            that.$router.replace({
              name: "login",
              params: { type: "not_log" },
            });
          } else {
            that.$message.error(`错误：${res.data.msg}`);
          }
        }
      });
    },
    // 获取客服管理表格数据
    getKfTable() {
      let that = this;
      opeGzhWxKf({
        gzh_id: that.wx_kf_get_id,
        status: [1, 4], // 1表示启用/正常。4表示已禁用
        order: "sort",
        sort: "asc",
      }).then((res) => {
        that.search_button_loading = false;
        that.wx_visible = true;
        console.log("跳转微信客服管理列表", res);
        let data = res.data.data.data;
        data.forEach((res, index) => {
          res.status_checked_loading = false; // 请求的加载状态
          res.checked = false;
          if (res.status == 1) {
            // 已启用
            res.checked = true;
          }
        });
        that.wx_tableShowData = data;
      });
    },
    // 新建微信客服
    addWxKf(type) {
      this.add_wx_drawer_title = "新增";
      this.wx_button_type = type;
      this.add_wx_visible = true;
    },
    // 新建微信客服-确认按钮
    wxRequest() {
      let that = this;
      if (that.wx_button_type == "新建客服") {
        if (!that.add_wx_kf_account_id && that.add_wx_drawer_title == "新增") {
          that.$message.warning("请先选择企业");
        } else if (!that.wx_kf_get_id && that.add_wx_drawer_title == "新增") {
          that.$message.warning("请先选择ID");
        } else if (!that.add_wx_kf_media_id) {
          that.$message.warning("请先上传图片");
        } else if (!that.add_wx_name) {
          that.$message.warning("请先输入客服名称");
        } else if (!that.add_wx_title) {
          that.$message.warning("请先输入欢迎语主角词");
        } else {
          that.add_wx_button_loading = true;
          if (that.add_wx_drawer_title == "新增") {
            opeGzhAddKf({
              account_id: that.add_wx_kf_account_id,
              gzh_id: that.wx_kf_get_id,
              media_id: that.add_wx_kf_media_id,
              name: that.add_wx_name,
              title: that.add_wx_title,
              sort: that.add_wx_sort,
            }).then((res) => {
              that.add_wx_button_loading = false;
              console.log("新建客服", res);
              if (
                res.data.code === 0 ||
                res.data.code === 200 ||
                res.data.code == 8011
              ) {
                that.$message.success("操作成功");
                that.add_wxCloseDrawer();
                that.getKfTable();
              } else {
                if (res.data.code === 401) {
                  // 未登录
                  localStorage.removeItem("access_token");
                  that.$router.replace({
                    name: "login",
                    params: { type: "not_log" },
                  });
                } else {
                  that.$message.error(`错误：${res.data.msg}`);
                }
              }
            });
          } else if (that.add_wx_drawer_title == "编辑") {
            opeGzhEditKf({
              id: that.edit_wx_kf_id,
              media_id: that.add_wx_kf_media_id,
              name: that.add_wx_name,
              title: that.add_wx_title,
              sort: that.add_wx_sort,
            }).then((res) => {
              that.add_wx_button_loading = false;
              console.log("编辑客服", res);
              if (
                res.data.code === 0 ||
                res.data.code === 200 ||
                res.data.code == 8011
              ) {
                that.$message.success("操作成功");
                that.add_wxCloseDrawer();
                that.getKfTable();
              } else {
                if (res.data.code === 401) {
                  // 未登录
                  localStorage.removeItem("access_token");
                  that.$router.replace({
                    name: "login",
                    params: { type: "not_log" },
                  });
                } else {
                  that.$message.error(`错误：${res.data.msg}`);
                }
              }
            });
          }
        }
      } else if (that.wx_button_type == "人工添加客服") {
        if (!that.add_wx_kf_account_id && that.add_wx_drawer_title == "新增") {
          that.$message.warning("请先选择企业");
        } else if (!that.wx_kf_get_id && that.add_wx_drawer_title == "新增") {
          that.$message.warning("请先选择ID");
        } else if (!that.add_wx_name) {
          that.$message.warning("请先输入客服名称");
        } else if (!that.add_kf_url) {
          that.$message.warning("请先输入客服URL");
        } else {
          that.add_wx_button_loading = true;
          if (that.add_wx_drawer_title == "新增") {
            opeGzhManAddKf({
              account_id: that.add_wx_kf_account_id,
              gzh_id: that.wx_kf_get_id,
              name: that.add_wx_name,
              kf_url: that.add_kf_url,
              sort: that.add_wx_sort,
            }).then((res) => {
              that.add_wx_button_loading = false;
              if (
                res.data.code === 0 ||
                res.data.code === 200 ||
                res.data.code == 8011
              ) {
                console.log("新建人工添加客服", res);
                that.$message.success("操作成功");
                that.add_wxCloseDrawer();
                that.getKfTable();
              } else {
                if (res.data.code === 401) {
                  // 未登录
                  localStorage.removeItem("access_token");
                  that.$router.replace({
                    name: "login",
                    params: { type: "not_log" },
                  });
                } else {
                  that.$message.error(`错误：${res.data.msg}`);
                }
              }
            });
          } else if (that.add_wx_drawer_title == "编辑") {
            opeGzhManEditKf({
              id: that.edit_wx_kf_id,
              kf_url: that.add_kf_url,
              name: that.add_wx_name,
              sort: that.add_wx_sort,
            }).then((res) => {
              that.add_wx_button_loading = false;
              console.log("编辑人工添加客服", res);
              if (
                res.data.code === 0 ||
                res.data.code === 200 ||
                res.data.code == 8011
              ) {
                console.log("编辑人工添加客服", res);
                that.$message.success("操作成功");
                that.add_wxCloseDrawer();
                that.getKfTable();
              } else {
                if (res.data.code === 401) {
                  // 未登录
                  localStorage.removeItem("access_token");
                  that.$router.replace({
                    name: "login",
                    params: { type: "not_log" },
                  });
                } else {
                  that.$message.error(`错误：${res.data.msg}`);
                }
              }
            });
          }
        }
      }
    },
    add_wxCloseDrawer() {
      if (this.add_wx_button_loading) {
        return;
      }
      this.imageUrl = "";
      this.add_wx_kf_account_id = undefined;
      // this.wx_kf_get_id = ""
      this.add_wx_kf_media_id = "";
      this.add_wx_name = "";
      this.add_wx_title = "";
      this.add_kf_url = "";
      this.add_wx_sort = 0;
      this.add_wx_visible = false;
    },
    // 选择企业
    handleChangeH(e) {
      console.log("选择企业", e);
      this.add_wx_kf_account_id = e;
    },
    // 头像上传。上传文件之前的钩子，参数为上传的文件，若返回 false 则停止上传
    beforeUpload(file) {
      console.log("beforeUpload", file);

      // if(this.add_wx_kf_account_id){
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        this.$message.error("You can only upload JPG file!");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("Image must smaller than 2MB!");
      }
      return isJpgOrPng && isLt2M;
      // }
      // else {
      // 	this.$message.warning('请先选择企业');
      // }
    },
    handleChangeImg(info) {
      console.log("图片请求", info);
      let that = this;
      if (info.file.status === "uploading") {
        this.loading = true;
        return;
      }
      if (info.file.status === "done") {
        if (info.file.response) {
          // 图片上传成功，有内容返回
          this.add_wx_kf_media_id = info.file.response.data.media_id;

          // Get this url from response in real world.
          getBase64(info.file.originFileObj, (imageUrl) => {
            this.imageUrl = imageUrl;
            this.loading = false;
          });
        } else {
          this.imageUrl = "";
          this.loading = false;
          this.$message.error(`错误：图片上传失败`);
        }
      }

      if (info.file.status === "error") {
        // 上传失败

        this.imageUrl = "";
        this.loading = false;
        this.$message.error(`错误：图片上传失败`);
      }
    },
    upImgHint() {
      this.$message.warning("请先选择企业");
    },

    // 切换-小程序打开内容
    jumpTypeChange(e, item) {
      // console.log(e.target.value);
      item.jump_type = e.target.value;
    },

    // 图片展示弹窗
    imgOk(e) {},
    showCodeImg(e) {
      console.log(e);
      this.show_modal_img = e;
      this.img_visible = true;
    },

    // 切换状态
    onChangeChecked(e, item) {
      console.log(e, item);
      let that = this;
      let sss;
      if (e) {
        // 开启
        sss = 1;
      } else {
        // 禁用
        sss = 4;
      }
      item.status_checked_loading = true;
      opeGzhChangeStatus({
        id: item.id,
        status: sss,
      }).then((res) => {
        console.log("切换状态", res);
        if (
          res.data.code === 0 ||
          res.data.code === 200 ||
          res.data.code == 8011
        ) {
          that.$message.success("操作成功");
          item.status_checked_loading = false;
          item.checked = e;
        } else {
          if (res.data.code === 401) {
            // 未登录
            localStorage.removeItem("access_token");
            that.$router.replace({
              name: "login",
              params: { type: "not_log" },
            });
          } else {
            that.$message.error(`${res.data.msg}`);
          }
        }
      });
    },

    // 客服表格排序
    useSort(e, item) {
      item.sort = e || 0;
    },
    // 更改顺序操作
    sortRequest(e) {
      let that = this;
      if (e == 1) {
        // 整理顺序
        that.wx_tableShowData.sort(function (a, b) {
          return a.sort - b.sort;
        });
      } else if (e == 2) {
        // 确认顺序
        that.sort_wx_button_loading = true;
        let s_data = that.wx_tableShowData;
        s_data.sort(function (a, b) {
          return a.sort - b.sort;
        });
        let ids = {};
        console.log("s_data", s_data);
        s_data.forEach((res, index) => {
          console.log("forEach", s_data[index].sort);
          ids[res.id] = res.sort;
        });
        console.log("ids", ids);
        opeGzhChangeSort({
          id_sorts: ids,
        }).then((res) => {
          that.sort_wx_button_loading = false;
          console.log("更改顺序", res);
        });
      }
    },

    // 增加人工客服需要的排序值
    addUseSort(e) {
      console.log(e);
      this.add_wx_sort = e || 0;
    },
  },
  filters: {
    wxTableStatus(value) {
      // console.log("过滤器",value)
      let vvv;
      if (value == 1) {
        vvv = "正常";
      } else if (value == 2) {
        vvv = "取消绑定";
      } else if (value == 3) {
        vvv = "删除";
      } else if (value == 4) {
        vvv = "已禁用";
      }
      return vvv;
    },
    statusFilters(value) {
      let vvv = "";
      if (value == 1) {
        vvv = "正常";
      } else if (value == 14) {
        vvv = "已注销";
      } else if (value == 16) {
        vvv = "已封禁";
      } else if (value == 18) {
        vvv = "已告警";
      } else if (value == 19) {
        vvv = "已冻结";
      }
      return vvv;
    },
    formatAdminUser(val) {
      const userList = [];
      if (Object.keys(val).length > 0) {
        for (const key in val) {
          userList.push(val[key]);
        }
        return userList.join(", ");
      }
      return "";
    },
  },
};
</script>

<style scoped>
/* 表格内的操作按钮 */
.cz-cell {
  color: #62a8ea;
  cursor: pointer;
  margin-right: 7px;
  margin-bottom: 5px;
}
.cz-cell:hover {
  color: rgb(47, 136, 255);
}

.class-title {
  width: 100px;
}

.set-xcx-box {
  position: relative;
  padding: 25px 15px 5px;
  margin-bottom: 15px;
  border-radius: 8px;
  background-color: #eff1f7;
}

.avatar-uploader img {
  max-width: 483px;
}
</style>
